import { render } from "./TmpPatientView.vue?vue&type=template&id=1db06eed&scoped=true"
import script from "./TmpPatientView.vue?vue&type=script&lang=js"
export * from "./TmpPatientView.vue?vue&type=script&lang=js"

import "./TmpPatientView.vue?vue&type=style&index=0&id=1db06eed&lang=scss&scoped=true"

import exportComponent from "D:\\NET\\AsdCare\\asdcare-internal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1db06eed"]])

export default __exports__